import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {FeatureFilterConfiguration} from "../core/config/feature-filter-configuration";
import {GeoICONS} from "../core/components/icon/icon";

@JsonObject()
export class TopicLayerConfiguration {
    @JsonProperty()
    declare id: string;
    @JsonProperty()
    declare layerId?: number;
    @JsonProperty()
    declare layerIds?: number[];
    constructor() {
    }
}
export class TopicLayersConfiguration {
    @JsonProperty()
    declare open?: TopicLayerConfiguration[];
    @JsonProperty()
    declare visible: TopicLayerConfiguration[];
    constructor() {
    }
}
@JsonObject() // "LayerConfiguration"
export class TopicConfiguration {

    /**
     * Identifier
     */
    @JsonProperty()
    declare id: string;

    @JsonProperty()
    declare parentId?: string;
    /**
     * Short name ( used in site title)
     */
    @JsonProperty()
    declare name?: string;

    /**
     * Label for displaying
     */
    @JsonProperty()
    declare label: string;

    /**
     * Icon type
     */
    @JsonProperty()
    declare icon: GeoICONS;

    /**
     * Ids of layers to apply the filter
     */
    @JsonProperty()
    declare layers: TopicLayersConfiguration;

    /**
     * filter to use for this topic
     */
    @JsonProperty()
    declare filter: FeatureFilterConfiguration;

    /**
     * Base IDs contained within this topic
     * Used to find stations when addressed by url (station no is not unique)
     */
    @JsonProperty()
    declare baseIds: number[];

    /**
     * Routes to access this topic
     * Add "/" to load the topic at startup
     */
    @JsonProperty()
    declare routes: string[];

    /**
     * Defines if aside is displayed
     */
    @JsonProperty()
    declare showAside: boolean;

    constructor() {}

    /**
     * Return true when topic is a subtopic
     */
    get isSubtopic(): boolean {
        return this.parentId != null && this.parentId.length > 0;
    }
}
